import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import SaveCarrierSelectionFormContainer from '../containers/SaveCarrierSelectionFormContainer';
import Modal from '../../../../core/modules/common/components/Modal';

class SaveCarrierSelectionModal extends Component {
  onSubmitSaveSelection = ({ name }) => {
    this.props.saveSelection({
      name,
      checkedCarriers: this.props.checkedCarriers,
    });
  };

  render() {
    return (
      <Modal
        header={
          <FormattedMessage
            id="app.save.carrier.selection.form.title"
            tagName="h3"
          />
        }
        closeOnOutsideClick
        onClose={this.props.closeModal}
      >
        <SaveCarrierSelectionFormContainer
          onSubmit={this.onSubmitSaveSelection}
          onCloseModal={this.props.closeModal}
          selections={this.props.selections}
          carriers={this.props.carriers}
        />
      </Modal>
    );
  }
}

SaveCarrierSelectionModal.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    carriers: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  checkedCarriers: PropTypes.arrayOf(PropTypes.string).isRequired,
  saveSelection: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  carriers: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default (SaveCarrierSelectionModal);
